<x-shop-dialog
  heading="Order is awaiting payment"
  subheading="You need to complete payment for this order or go back to shop."
  [canClose]="true"
  (closeDialog)="closeDialog()"
>
  <x-shop-dialog-actions>
    <button
      xAction
      xRedirectBack
      (click)="closeDialog()"
      type="button"
      mat-stroked-button
      color="primary"
    >
      <ng-container i18n="@@CallToAction.BackToShop">Back to Shop</ng-container>
    </button>

    <button
      mat-flat-button
      color="primary"
      xAction
      (click)="closeDialog()"
      i18n="@@CallToAction.Continue"
    >
      Continue
    </button>
  </x-shop-dialog-actions>
</x-shop-dialog>
